import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Box,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StoreIcon from '@mui/icons-material/Store';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { text: 'Servicios', path: '/', icon: <HomeIcon /> },
    { text: 'Promociones', path: '/promociones', icon: <LocalOfferIcon /> },
    { text: 'Sucursales', path: '/sucursales', icon: <StoreIcon /> },
    { text: 'Días', path: '/dias', icon: <CalendarTodayIcon /> },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 240,
          boxSizing: 'border-box',
          backgroundColor: '#1e1e2f',
          color: '#fff',
        },
      }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap sx={{ color: '#fff' }}>
          Panel Admin
        </Typography>
      </Toolbar>

      <Box sx={{ mt: 2 }}>
        <List>
          {menuItems.map(({ text, path, icon }) => (
            <ListItem key={text} disablePadding>
              <ListItemButton
                component={Link}
                to={path}
                selected={location.pathname === path}
                sx={{
                  color: 'inherit',
                  '&.Mui-selected': {
                    backgroundColor: '#30304d',
                    '&:hover': {
                      backgroundColor: '#3e3e5e',
                    },
                  },
                  '&:hover': {
                    backgroundColor: '#2c2c45',
                  },
                }}
              >
                <ListItemIcon sx={{ color: 'inherit' }}>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
